import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import PropTypes from 'prop-types';
import orderStyle from 'pages/orders/style';
import OverflowTooltip from 'components/OverflowTooltip';

const Accordian = ({ title, isExpanded, onChange, children }) => {
    return (
        <Accordion
            data-testid="order-catalog-accordion"
            expanded={isExpanded}
            elevation={1}
            onChange={onChange}
            sx={orderStyle.orderCatalogServices.accordian}
            className="borderclass"
        >
            <AccordionSummary sx={orderStyle.orderCatalogServices1.container} expandIcon={<ExpandMoreIcon sx={{ color: '#000', fontWeight: '700' }} />}>
                <OverflowTooltip sx={orderStyle.orderCatalog?.titleText} component="span">
                    {title}
                </OverflowTooltip>
            </AccordionSummary>
            <AccordionDetails sx={orderStyle.orderCatalogServices.children}>{children && <>{children}</>}</AccordionDetails>
        </Accordion>
    );
};

Accordian.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    isExpanded: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

Accordian.defaultProps = {
    title: 'Title Here',
    children: undefined,
};

export default Accordian;
